<template>
  <div>
    <div class="box">
      <ul>
        <li class="qrbox"><img :src="qr" /></li>
        <li class="title">
          <i class="titleLine"></i>
          <i class="titleName">使用说明</i>
          <i class="titleLine"></i>
        </li>
        <li class="instructions">手指长按图中二维码，在弹出菜单中点击 识别图中二维码或图中包含公众号 即可前往关注</li>
      </ul>
    </div>
  </div>
</template>

<script>
var self;
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import ModelLoading from '@/components/ModelLoading.vue'
export default {
  name: 'qr',
  components: {
    'K-Loading': Loading,
    'K-ModelLoading': ModelLoading
  },
  data () {
    return {
      qr:null,
      code:null
    }
  },
  created () {
    self = this;
    self.code = self.GetCode();
    self.qr = this.$route.query.qr;
    console.log(this.$route.query.qr);
  }
}
</script>

<style scoped>
  .box{
    margin:.5rem;
    overflow: hidden;
    border-radius: .3rem;
    background-color: #FFF;
    padding-bottom: .6rem;
    box-shadow: 0 0 5px rgba(100,100,100,0.2);
  }
  .qrbox{
    width: 11rem;
    display: table;
    margin:1rem auto;
  }
  .qrbox img{
    width: 100%;
    display: block;
  }
  .title{
    font-size:.58rem;
    overflow: hidden;
    display: table;
    margin:0 auto;
  }
  .title i{
    display: block;
    float: left;
  }
  .titleName{
    color:#333;
    padding:0 .5rem;
  }
  .titleLine{
    height:.4rem;
    width: 2rem;
    border-bottom: 1px solid #EEE;
  }
  .instructions{
    padding:.5rem;
    color:#666;
    line-height: .9rem;
  }
</style>



// WEBPACK FOOTER //
// src/public-view/Qr.vue